import { routeForStep, useOnboarding } from "@/hooks/use-onboarding";
import type { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

export const SlashRedirect: FC = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { state } = useLocation();
    const { steps } = useOnboarding();
    const completed = steps.steps.every((step) => step.completed);
    const to = completed ? "/projects" : routeForStep(steps.defaultActive);

    if (steps.isLoading) {
        return null;
    }

    return (
        <Navigate
            to={{ pathname: to, hash: document.location.hash }}
            replace
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            state={{ ...state, showCreateModal: !!document.location.hash }}
        />
    );
};
